import React, { useState } from 'react';
import "../create_com.css";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Navbar from '../Navbar';
import { toast } from 'react-toastify';
import Menu_Items from '../Menu_Items';
import { MdAddToPhotos } from "react-icons/md";

function Create_com() {
  const [inval, setinval] = useState({});
  const navigate = useNavigate();

  const handledata = (e) => {
    setinval({ ...inval, [e.target.id]: e.target.value });
  }
  const submit = async () => {
    await axios.post("/company/add", inval).then((res) => {
      navigate("/company");
    }).catch((err) => {
      toast.error('Error', {
        autoClose: 2000, // 2 seconds
      });
    });
  };
  return (
    <>
      <div className='container df fdc jb ac'>
        <Navbar />
        <div className='main_box df'>
          <Menu_Items />
          <div className='content df fdc ac'>
            <div className='page_header df ac'>
              <div className='w90 df ac'><MdAddToPhotos className='page_icon db' /><p>Create Company</p></div>
            </div>
            <div className='box'>
              <div className='create_box'>
                <div>
                  <label htmlFor='name'>Company Name</label>
                  <input type='search' id='name' onChange={(e) => { handledata(e) }} placeholder='Enter Company Name' />
                </div>
                <div>
                  <label htmlFor='code'>Company Code</label>
                  <input type='search' id='code' onChange={(e) => { handledata(e) }} placeholder='Enter Company Name' />
                </div>
                <div>
                  <label htmlFor='mail'>E-Mail ID</label>
                  <input type="search" id='mail' onChange={(e) => { handledata(e) }} placeholder='Enter E-Mail ID' />
                </div>
                <div>
                  <label htmlFor='mobile'>Mobile No</label>
                  <input type="number" id='mobile' onChange={(e) => { handledata(e) }} placeholder='Enter Mobile No' />
                </div>
                <div>
                  <label htmlFor='no_integration'>No Of Integration</label>
                  <input type="number" id='no_integration' onChange={(e) => { handledata(e) }} placeholder='Enter Company Name' />
                </div>
                <div>
                  <label htmlFor='uname'>User Name</label>
                  <input type="search" id='uname' onChange={(e) => { handledata(e) }} placeholder='Enter User Name' />
                </div>
                <div>
                  <label htmlFor='password'>Password</label>
                  <input type="search" id='password' onChange={(e) => { handledata(e) }} placeholder='Enter Password' />
                </div>
              </div>
              <div className='w100 h10 df jc ac white'>
                <button className='btn green' onClick={submit}>Submit</button>
              </div>
            </div>
          </div>
        </div>
        {/* <div className='h_btn df jc ac'>
          <p className='df jc ac'>Create Company</p>
        </div> */}

        {/* <Back location={`/company`} /> */}
      </div >
    </>
  )
}

export default Create_com;